import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { columns } from './services-grid-columns';
import { servicesApiKeyStore } from '../../../../api/masters/services-api-key-store';
import { UserPermissionName } from '../../../../models/user-permission-name';
import { useEffect, useState } from 'react';
import { State } from '@progress/kendo-data-query';
import { GridColumnConfig, GridPreference } from '../../../../models/gridCoumnConfig';
import { gridApiKeyStore } from '../../../../api/grid-api-key-store';
import { useLoadData } from '../../../../hooks/useLoadData';
import { ApiResponse } from '../../../../models/api-response';
import { Service } from '../../../../models/masters/service';
import { useSaveData } from '../../../../hooks/useSaveData';
import useDebounce from '../../../../hooks/use-debounce';

interface ProjectsTabProps {
  officeID: number;
}

const DEFAULT_GROUP = [
  {
    field: 'serviceGroupName',
  },
];

export const ServicesTab = ({ officeID }: ProjectsTabProps) => {
  // -------------------------------------------------Grid Layout------------------------------

  const {
    isLoading: isLoadingGridLayout,
    data: gridLayouts,
    refetch: refetchGridLayout,
  } = useLoadData<ApiResponse<GridPreference>>(gridApiKeyStore.getGridLayout('Office Details', 'Service'));

  const {
    isLoading,
    data: Services,
    refetch,
  } = useLoadData<ApiResponse<Service[]>>(servicesApiKeyStore.getServiceOfficeMappings(officeID));

  const { mutateAsync } = useSaveData<any>(gridApiKeyStore.saveGridLayOut());
  const [gridConfig, setGridConfig] = useState<{
    dataState: State | undefined;
    columns: any[] | undefined;
  }>();

  const [filteredServices, setFilteredServices] = useState<Service[]>([]);

  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  useEffect(() => {
    const filteredServicetList = Services?.data?.filter((Project) =>
      Object.values(Project).some(
        (value) => value && value.toString().toLowerCase().includes(debouncedSearchTerm.toLowerCase())
      )
    );
    setFilteredServices(filteredServicetList || []);
  }, [debouncedSearchTerm, Services?.data]);

  const handleInputChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleSaveLayout = (gridDataState: State, gridColumns: GridColumnConfig[]) => {
    const data = {
      filterJSON: JSON.stringify(gridDataState),
      columnJSON: JSON.stringify(gridColumns),
      gridName: 'Service',
      pageName: 'Office Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  const handleResetLayout = () => {
    const data = {
      filterJSON: null,
      columnJSON: null,
      gridName: 'Service',
      pageName: 'Office Details',
    };

    mutateAsync({ data }).then(() => {
      refetchGridLayout();
    });
  };

  useEffect(() => {
    if (!gridLayouts?.data) return;

    try {
      const filterData = gridLayouts.data.filterJSON ? JSON.parse(gridLayouts.data.filterJSON) : null;

      const columnJson = gridLayouts.data.columnJSON ? JSON.parse(gridLayouts.data.columnJSON) : null;

      // if (filterData && columnJson) {
      setGridConfig({
        columns: columnJson,
        dataState: filterData,
      });
      // }
    } catch (error) {
      console.log('Error parsing grid layout JSON:', error);
    }
  }, [gridLayouts?.data]);
  return (
    <SiTrackGrid
      fileTitle='office_service'
      columns={columns}
      dataItemKey="serviceID"
      // queryConfig={servicesApiKeyStore.getServiceOfficeMappings(officeID)}
      // defaultGroup={DEFAULT_GROUP}
      actionPermissions={{
        export: UserPermissionName.DOWNLOAD_GRID,
      }}
      // -----------------Grid Layout-------
      dataItems={filteredServices || []}
      reorderable
      handleSearch={handleInputChange}
      handleSaveLayout={handleSaveLayout}
      isSaveLayout={true}
      gridConfigFromApi={gridConfig}
      handleResetLayout={handleResetLayout}
    // -----------------Grid Layout-------
    />
  );
};
